<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/order/appeal/table">工单申诉管理</el-breadcrumb-item>
        <el-breadcrumb-item>申诉详情 #{{ $route.params.id }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">申诉信息</template>
      <div v-loading="loading">
        <el-table :data="infoList"
                  :show-header="false"
                  border
                  class="appeal-info-table">
          <el-table-column prop="key"
                           width="150">
            <template slot-scope="scope">
              <span class="table-detail-title">{{ scope.row.key }}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="300">
            <template slot-scope="scope">
              <router-link v-if="scope.row.type === 'link'"
                           :to="scope.row.link"
                           class="blue-color">{{ scope.row.value }}</router-link>
              <el-tag v-else-if="scope.row.type === 'tag'"
                      :type="getAppealStatusTag(scope.row.value)"
                      size="mini">{{ getAppealStatusLabel(scope.row.value) }}</el-tag>
              <span v-else>{{ scope.row.value }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </layout-panel>

    <layout-panel>
      <template slot="header">申诉材料</template>
      <div v-if="detail.appeal_materials && detail.appeal_materials.length"
           id="appealPhotoContainer">
        <div v-for="(m, i) in detail.appeal_materials"
             :key="i"
             style="display:inline-block;margin-right:12px;vertical-align:top;">
          <video v-if="m.type === 'video'"
                 :src="m.url"
                 class="photo-view-image video-preview"
                 preload="metadata"
                 @click="openVideoDialog(m.url, i)"></video>
          <img v-else-if="m.type === 'img'"
               :src="m.url | ossFormatJpg"
               @click="onViewPhotos(i)"
               alt=""
               class="photo-view-image">
          <a v-else :href="m.url" target="_blank">{{ m.name || m.url }}</a>
        </div>
      </div>
      <div v-else class="empty-tip">暂无材料</div>
    </layout-panel>

    <video-player-dialog
      :visible.sync="videoDialogVisible"
      :videos="videoDialogVideos"
      :index="videoDialogIndex" />

    <layout-panel>
      <template slot="header">操作记录</template>
      <div v-if="detail.logs && detail.logs.length"
           class="log-list">
        <div v-for="(log, i) in detail.logs"
             :key="i"
             class="log-item">
          <span class="log-time">{{ log.created_at }}</span>
          <b>{{ log.operator_name || '-' }}</b>
          <span v-if="log.operator_id != null">（{{ log.operator_id }}）</span>：
          {{ log.msg }}
        </div>
      </div>
      <div v-else class="empty-tip">暂无记录</div>
    </layout-panel>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import Viewer from 'viewerjs'
import { orderAppealMixin } from '@views/order/mixins/order-appeal.mixins.js'
import VideoPlayerDialog from '@views/user-workinfo/components/VideoPlayerDialog.vue'

export default {
  mixins: [orderAppealMixin],
  components: { VideoPlayerDialog },
  data () {
    return {
      loading: false,
      detail: {},
      viewer: null,
      videoDialogVisible: false,
      videoDialogVideos: [],
      videoDialogIndex: 0,
    }
  },
  computed: {
    infoList () {
      const d = this.detail || {}
      const status = Number(d.status)
      const rows = [
        { key: '申诉ID', value: d.id != null ? d.id : '-' },
        d.orderid
          ? { key: '工单ID', type: 'link', link: '/order/detail/' + d.orderid, value: 'ORD' + d.orderid }
          : { key: '工单ID', value: '-' },
        { key: '申诉零工ID', value: d.userid != null ? d.userid : '-' },
        { key: '申诉状态', type: 'tag', value: d.status },
        { key: '客户名称/ID', value: (d.customer_name || '-') + ' / ' + (d.customerid || '-') },
        { key: '项目名称/编号', value: (d.project_name || '-') + ' / ' + (d.project_number || '-') },
        { key: '批次名称/编号', value: (d.batch_name || '-') + ' / ' + (d.batch_number || '-') },
        { key: '任务ID', value: d.taskid != null ? d.taskid : '-' },
        { key: '最后审核人', value: d.order_reviewer_id > 0 ? `${d.order_reviewer_name} / ${d.order_reviewer_id}` : ''},
        { key: '申诉处理人', value: d.audit_adminid > 0 ? `${d.audit_adminname} / ${d.audit_adminid}` : '-' },
        { key: '冻结零豆', value: d.frozen_point != null ? d.frozen_point : '-' },
        { key: '补偿零豆', value: d.status === 2 ? d.compensate_point : '-' },
        { key: '发起时间', value: d.created_at || '-' },
        { key: '申诉处理时间', value: d.audited_at || '-' },
        { key: '申诉原因', value: d.appeal_reason || '-' },
      ]

      // status=2 申诉通过：展示实习生错审原因与通过备注
      if (status === 2) {
        rows.push(
          { key: '实习生错审原因', value: d.reviewer_wrong_reason != null ? d.reviewer_wrong_reason : '-' },
          { key: '申诉通过备注', value: d.pass_remarks || '-' },
        )
      }
      // status=3 申诉驳回：展示驳回原因与驳回备注
      if (status === 3) {
        rows.push(
          { key: '驳回原因', value: d.reject_reason != null ? d.reject_reason : '-' },
          { key: '申诉驳回备注', value: d.reject_remarks || '-' },
        )
      }
      return rows
    },
  },
  created () {
    this.fetchDetail()
  },
  beforeDestroy () {
    if (this.viewer) {
      this.viewer.destroy()
      this.viewer = null
    }
  },
  methods: {
    getAppealStatusLabel (value) {
      const item = this.appealStatusOptions.find(i => i.value === value)
      return item ? item.label : '未知'
    },
    getAppealStatusTag (value) {
      const map = {1: 'warning', 2: 'success', 3: 'danger', 4: 'info', 5: 'info'}
      return map[value] || 'info'
    },
    fetchDetail () {
      const id = this.$route.params.id
      this.loading = true
      return request.common('getOrderAppealDetail', { id })
        .then(res => {
          this.detail = res.data || {}
        })
        .finally(() => {
          this.loading = false
        })
    },
    onViewPhotos (index) {
      if (this.viewer) {
        this.viewer.destroy()
      }
      this.viewer = new Viewer(document.getElementById('appealPhotoContainer'))
      this.viewer.view(index)
    },
    openVideoDialog (url, index) {
      const videoList = (this.detail.appeal_materials || [])
        .filter(m => m.type === 'video')
        .map(m => m.url)
      this.videoDialogVideos = videoList
      this.videoDialogIndex = Math.max(videoList.indexOf(url), 0)
      this.videoDialogVisible = true
    },
  },
}
</script>

<style lang="scss" scoped>
.blue-color {
  color: rgb(88, 157, 248);
  text-decoration: none;
}
.empty-tip {
  color: #909399;
  font-size: 13px;
  padding: 12px 0;
}
.appeal-info-table {
  font-size: 14px;
}
.table-detail-title {
  color: #909399;
}
.photo-view-image {
  width: 120px;
  height: 120px;
  object-fit: cover;
  cursor: pointer;
}
.video-preview {
  position: relative;
  cursor: pointer !important;
  background-color: #000;
}
.log-time {
  color: #909399;
  margin-right: 8px;
}
.log-list {
  padding-left: 8px;
}
.log-item {
  position: relative;
  padding: 0 0 16px 20px;
  line-height: 1.5;
}
.log-item::before {
  content: '';
  position: absolute;
  left: 4px;
  top: 7px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #c0c4cc;
  z-index: 1;
}
.log-item::after {
  content: '';
  position: absolute;
  left: 7px;
  top: 15px;
  bottom: 0;
  width: 2px;
  background: #ebeef5;
}
.log-item:last-child {
  padding-bottom: 0;
}
.log-item:last-child::after {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/order/pages/OrderAppealDetail.vue